const LOCALHOST = "http://127.0.0.1";
export const PYTHON_BACKEND_URL = `${LOCALHOST}:8000`;
export const EXCEL_BACKEND_URL = `${LOCALHOST}:8001`;
export const APP_MANAGER_URL = `${LOCALHOST}:8765`;
